var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM12 10.9668C11.8897 10.967 11.8008 11.0566 11.8008 11.167V11.8008H11.167C11.0566 11.8008 10.967 11.8897 10.9668 12C10.967 12.1103 11.0567 12.2002 11.167 12.2002H11.8008V12.834C11.8012 12.944 11.8899 13.033 12 13.0332C12.1101 13.033 12.1998 12.944 12.2002 12.834V12.2002H12.834C12.944 12.1998 13.033 12.1101 13.0332 12C13.033 11.8899 12.944 11.8011 12.834 11.8008H12.2002V11.167C12.2002 11.0566 12.1103 10.967 12 10.9668Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2C12.1046 2 13 2.89543 13 4V9.17383C12.6869 9.06306 12.351 9 12 9C10.3431 9 9 10.3431 9 12C9 12.7695 9.29228 13.469 9.76855 14H5C3.89543 14 3 13.1046 3 12V4C3 2.89543 3.89543 2 5 2H11ZM5.42871 8C5.19202 8 5 8.22386 5 8.5C5 8.77614 5.19202 9 5.42871 9H8.57129C8.80798 9 9 8.77614 9 8.5C9 8.22386 8.80798 8 8.57129 8H5.42871ZM5.42871 6C5.19202 6 5 6.22386 5 6.5C5 6.77614 5.19202 7 5.42871 7H10.5713C10.808 7 11 6.77614 11 6.5C11 6.22386 10.808 6 10.5713 6H5.42871ZM5.42871 4C5.19202 4 5 4.22386 5 4.5C5 4.77614 5.19202 5 5.42871 5H10.5713C10.808 5 11 4.77614 11 4.5C11 4.22386 10.808 4 10.5713 4H5.42871Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormBuilder);
export default __webpack_public_path__ + "static/media/form-builder.c8c62450ad4c575214652fd98d822f31.svg";
export { ForwardRef as ReactComponent };